import * as z from "zod";

export const additionalFieldEntitySchema = z.enum([
  "apartment",
  "holding",
  "lease",
  "organization",
  "person",
  "sublet",
]);
export const additionalFieldTypeSchema = z.enum([
  "text",
  "number",
  "date",
  "boolean",
  "select",
]);
export const additionalFieldSchema = z.object({
  name: z.string(),
  entity: additionalFieldEntitySchema,
  type: additionalFieldTypeSchema,
  options: z.array(z.string()).optional(),
  required: z.boolean(),
});
export const additionalFieldsSchema = z.array(additionalFieldSchema);
export const additionalFieldWithLabelSchema = additionalFieldSchema.extend({
  label: z.string(),
  options: z
    .array(
      z.object({
        value: z.string(),
        label: z.string(),
      }),
    )
    .optional(),
});

export const additionalDataSchema = z
  .record(z.string(), z.unknown())
  .optional();

export type AdditionalField = z.infer<typeof additionalFieldSchema>;
export type AdditionalFieldEntity = z.infer<typeof additionalFieldEntitySchema>;
export type AdditionalFieldType = z.infer<typeof additionalFieldTypeSchema>;
export type AdditionalFieldWithLabel = z.infer<
  typeof additionalFieldWithLabelSchema
>;

export type AdditionalData = z.infer<typeof additionalDataSchema>;
